export default __webpack_public_path__ + "static/media/logo-sm-light.5e10730e.png";